export default __webpack_public_path__ + "static/media/full-screen-disabled.20179ebb.svg";